(() => {
  'use strict';
  const config = document.querySelector('script[data-herqs-accessibility]');
  if (!config) return;
  const rules = [
    ['.aimode-attachment-input', config.dataset.attachment],
    ['.aimode-sbar-input', config.dataset.productSearch],
    ['.ts-country .ts-search__input', config.dataset.countrySearch]
  ];
  const label = scope => {
    if (!(scope instanceof Element)) return;
    rules.forEach(([selector, name]) => {
      const elements = [...scope.querySelectorAll(selector)];
      if (scope.matches(selector)) elements.push(scope);
      elements.forEach(element => {
        if (!element.getAttribute('aria-label') && !element.getAttribute('aria-labelledby') && !element.labels?.length) element.setAttribute('aria-label', name);
      });
    });
  };
  label(document.body);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(label));
  }).observe(document.body, { childList: true, subtree: true });
})();
